const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  915: {
    path: "/earlyWarningManager",
    name: "earlyWarningManager",
    meta: {
      title: "预警管理",
      authId: "915",
      parentId: "1",
      cache: false
    }
  },
  91501: {
    path: "/staffWarn",
    name: "staffWarn",
    meta: {
      title: "员工预警管理",
      authId: "91501",
      parentId: "915",
      cache: false
    },
    auth: [
      {
        authId: "9150101",
        parentId: "91501",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9150102",
        parentId: "91501",
        label: "查看",
        handle: "handleDetail"
      },
      {
        authId: "9150103",
        parentId: "91501",
        label: "处理",
        handle: "handleDeal"
      }
    ],
    component: _import("earlyWarningManager/staff/indexControl")
  },
  // 91502: {
  //   path: "/storeWarn",
  //   name: "storeWarn",
  //   meta: {
  //     title: "门店预警管理",
  //     authId: "91502",
  //     parentId: "915",
  //     cache: false
  //   },
  //   auth: [
  //     {
  //       authId: "9150201",
  //       parentId: "91502",
  //       label: "导出",
  //       category: "Button",
  //       type: "primary",
  //       handle: "handleExport"
  //     },
  //     {
  //       authId: "9150202",
  //       parentId: "91502",
  //       label: "查看",
  //       handle: "handleDetail"
  //     },
  //     {
  //       authId: "9150203",
  //       parentId: "91502",
  //       label: "处理",
  //       handle: "handleDeal"
  //     }
  //   ],
  //   component: _import("earlyWarningManager/store/indexControl")
  // },
  91503: {
    path: "/shopGuard",
    name: "shopGuard",
    meta: {
      title: "店效盯防",
      authId: "91503",
      parentId: "915",
      cache: false
    },
    auth: [
      {
        authId: "9150201",
        parentId: "91503",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9150202",
        parentId: "91503",
        label: "查看",
        handle: "handleDetail"
      },
      {
        authId: "9150203",
        parentId: "91503",
        label: "处理",
        handle: "handleDeal"
      }
    ],
    component: _import("earlyWarningManager/shopGuard/indexControl")
  },
}
